// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.trips-search input::placeholder {
  color: #ffffff;
}
.dropdown-menu-auto-suggest {
  display: block;
  position: absolute;
  margin-left: 10px;
}
.dropdown-menu-auto-suggest li a:hover {
  background-color: #337ab7;
  color: #ffffff;
}
.dropdown-menu-auto-suggest li .highlight {
  font-weight: bold;
}
.dropdown-menu-auto-suggest li .highlighted {
  background-color: #337ab7;
  color: white;
  font-weight: bold;
}
.dropdown-menu-auto-suggest .highlighted {
  background-color: #337ab7;
  color: white;
  font-weight: bold;
}
.dropdown-menu-auto-suggest .highlighted a {
  color: white;
  text-decoration: none;
}
`, "",{"version":3,"sources":["webpack://./src/styles/modules/trips.less"],"names":[],"mappings":"AAEA;EAEI,cAAA;AAFJ;AAMA;EACE,cAAA;EACA,kBAAA;EACA,iBAAA;AAJF;AACA;EAOM,yBAAA;EACA,cAAA;AALN;AAHA;EAWM,iBAAA;AALN;AANA;EAcM,yBAAA;EACA,YAAA;EACA,iBAAA;AALN;AAXA;EAoBI,yBAAA;EACA,YAAA;EACA,iBAAA;AANJ;AAhBA;EAwBM,YAAA;EACA,qBAAA;AALN","sourcesContent":["@color: #ffffff;\n\n.trips-search {\n  input::placeholder {\n    color: @color;\n  }\n}\n\n.dropdown-menu-auto-suggest {\n  display: block;\n  position: absolute;\n  margin-left: 10px;\n\n  li {\n    a:hover {\n      background-color: #337ab7;\n      color: #ffffff;\n    }\n    .highlight {\n      font-weight: bold;\n    }\n    .highlighted {\n      background-color: #337ab7;\n      color: white;\n      font-weight: bold;\n    }\n  }\n  .highlighted {\n    background-color: #337ab7;\n    color: white;\n    font-weight: bold;\n    a {\n      color: white;\n      text-decoration: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
